<div class="modal-header">

	<h5>{{notification.documentType | uppercase}}</h5>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<!-- BEGIN NOTIFICATION  -->
<div class="modal-body col-12 notification-detail-body">
	<div class="row">
		<div class="col-6">
			<h5><strong>Customer #:</strong></h5> {{notification.customerNumber}}<br><br>
			<h5><strong>Date: </strong></h5>{{notification.date| date:'MM/dd/yyyy'}}
		</div>
		<div class="col-6">
			<h5><strong>Document ID: </strong></h5>{{notification.documentId}}<br><br>
			<h5><strong>Reference ID: </strong></h5>{{notification.referenceID}}

		</div>
	</div>
	<br>

	<div class="row">
		<div class="col-6">
			<address>
				<h5><strong>From:</strong></h5><br>
				{{notification.fromAddressName}}<br>
				{{notification.fromLocationNumber}}<br>
				{{notification.fromContactName}}<br>
				{{notification.fromContactPhone}}<br>
				{{notification.fromContactEmail}}
			</address>
		</div>
		<div class="col-6">
			<address>
				<h5><strong>To:</strong></h5><br>
				{{notification.toAddressName}}<br>
				{{notification.toLocationNumber}}<br>
				{{notification.toContactName}}<br>
			</address>
		</div>
	</div>


	<div class="row">
		<div class="col-12">
			<h5><strong>Comments:</strong></h5> {{notification.listComments}}

		</div>
	</div>


	<br>

	<div class="row">
		<div class="col-12">

			<table class="table table-borderless">
				<caption style="display: none;"></caption>
				<thead>
					<tr class="border">
						<th class="text-center"><h5><strong>ID</strong></h5></th>
						<th class="text-center"><h5><strong>DESCRIPTION</strong></h5></th>
						<th class="text-right"><h5><strong>QTY</strong></h5></th>
						<th class="text-right"><h5><strong>AMT</strong></h5></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let reference of notification.messageReferences; let i=index">
						<tr class="border-top">
							<td rowspan="{{reference.messageReferenceDetails.size}}">{{reference.referenceId}}</td>
							<td>{{reference.description}}</td>
							<td class="text-right">
								<ng-container *ngIf="reference.quantity != 0">{{reference.quantity | number}}</ng-container>
							</td>
							<td class="text-right">
								<ng-container *ngIf="reference.monetaryAmount != 0">{{reference.monetaryAmount | currency}}</ng-container>
							</td>
						</tr>
						<ng-container *ngFor="let referenceDetails of reference.messageReferenceDetails; let i=index">
							<tr class="border">
								<td></td>
								<td>
									<ng-container *ngIf="referenceDetails.description">Desc: {{referenceDetails.description}}</ng-container>
								</td>
								<td>
									<ng-container *ngIf="referenceDetails.message">Mssg: {{referenceDetails.message}}</ng-container>

								</td>
								<td>
									<ng-container *ngIf="referenceDetails.errorCode">Error Code: {{referenceDetails.errorCode}}</ng-container>

								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>

	<!-- END NOTIFICATION -->
</div>

<div class="modal-footer notification-detail-footer" *ngIf="!(notification.statusFlag === 'P')">
	<button mat-raised-button color="accent" class="margin-buttons-form-field" (click)="process()">
		Mark As Processed
	</button>
</div>
